import React from 'react';
import { DollarSign, Users } from 'lucide-react';
import SourceBreakdownPanel from './SourceBreakdownPanel';

const SourceBreakdownGrid = ({ stats }) => (
  <div className="grid md:grid-cols-2 gap-6 mb-8">
    <SourceBreakdownPanel
      title="Seller leads by source"
      icon={DollarSign}
      iconTint="emerald"
      badgeTint="emerald"
      rows={stats?.sellerBySource || []}
    />
    <SourceBreakdownPanel
      title="Buyer leads by source"
      icon={Users}
      iconTint="amber"
      badgeTint="amber"
      rows={stats?.buyerBySource || []}
    />
  </div>
);

export default SourceBreakdownGrid;
